import { render, staticRenderFns } from "./XFooter.vue?vue&type=template&id=4d79b396&scoped=true&"
import script from "./XFooter.vue?vue&type=script&lang=js&"
export * from "./XFooter.vue?vue&type=script&lang=js&"
import style0 from "./XFooter.vue?vue&type=style&index=0&id=4d79b396&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d79b396",
  null
  
)

export default component.exports